import { settings } from "@thegetty-private/rad-app-utils";

const ID_MANAGER_DATA_URL = "https://data.getty.edu/publications";

/**
 * Gets the location message for the banner
 *
 * @returns {string}
 */
export function getLocationBanner() {
  return settings.getLocationBanner();
}

/**
 * Gets the Base URL
 * @return {String} -- the URL value
 */
export function getBaseUrl() {
  return settings.getConfigValue("BASE_URL", undefined, "/");
}

/**
 * Gets the App URL
 * @return {String} -- the URL value
 */
export function getAppUrl() {
  return settings.getConfigValue("APP_URL", undefined, "/");
}

/**
 * Gets the Data URL where to request data from (LOD Gateway or local dev)
 * @return {String} -- the URL value
 */
export function getDataUrl(defaultValue) {
  return settings.getConfigValue("DATA_URL", undefined, defaultValue);
}

/**
 * Checks whether we should display the product details table on the work page
 *
 * @returns {Boolean} - whether to show the product details table tab
 * @default true
 */
export function showProductDetailsTab() {
  return settings.getBooleanConfigValue(
    "SHOW_PRODUCT_DETAILS_TAB",
    undefined,
    true
  );
}

export function limitGettyPublisherNames() {
  return settings.getBooleanConfigValue(
    "LIMIT_GETTY_PUBLISHER_NAMES",
    undefined,
    true
  );
}

/**
 * The Base URL used by the ID Manager Data URL
 *
 * @returns {String}
 */
export function getIdManagerDataUrl(defaultValue = ID_MANAGER_DATA_URL) {
  return settings.getConfigValue(
    "ID_MANAGER_DATA_URL",
    undefined,
    defaultValue
  );
}

/**
 * The URL for Sitewide Search
 *
 * @returns {String}
 */
export function getSitewideSearchUrl() {
  return settings.getConfigValue(
    "SITEWIDE_SEARCH_URL",
    undefined,
    "https://www.getty.edu/search/api/related"
  );
}

/**
 * Gets the API path
 * this is the base path for the API
 * @return {String} -- the path value
 */
export function getApiPath() {
  return settings.getApiPath();
}

/**
 * Gets the URL for the feedback form
 *
 * @returns {String}
 */
export function getFeedbackFormUrl() {
  return settings.getFeedbackFormUrl();
}

/**
 * Whether to show the feedback form button
 *
 * @returns {boolean}
 */
export function showFeedbackButton() {
  return settings.getBooleanConfigValue(
    "SHOW_FEEDBACK_BUTTON",
    undefined,
    true
  );
}

/**
 * Whether to show the Publisher facet in the search facetExplorer
 *
 * @returns {boolean}
 */
export function showPublisherFacet() {
  return settings.getBooleanConfigValue(
    "SHOW_PUBLISHER_FACET",
    undefined,
    false
  );
}

/**
 * Whether to show the Publisher facet in the search facetExplorer
 *
 * @returns {boolean}
 */
export function showProgramFacet() {
  return settings.getBooleanConfigValue("SHOW_PROGRAM_FACET", undefined, true);
}

export function useExpandedRelatedResources() {
  return settings.getBooleanConfigValue(
    "USE_IDMUI_RELATIONSHIPS",
    undefined,
    false
  );
}
